"use client";

import { useHydrated } from "@/hooks/useHydrated";
import { HomepageDemo as HomepageDemoImpl } from "@/components/home/homepage-demo";

export function HomepageDemo() {
  const hydrated = useHydrated();
  if (!hydrated) {
    return (
      <div
        id="live-demo"
        className="mx-auto max-w-6xl scroll-mt-24 px-5 py-6 sm:px-8 sm:py-8"
      >
        <div className="bg-card/70 h-[340px] animate-pulse rounded-[28px]" />
      </div>
    );
  }
  return <HomepageDemoImpl />;
}
